import client from './client';
import { Supplier } from '../types/entities';
import { ApiResponse, CreateSupplierRequest } from '../types/api';

export const supplierAPI = {
  getAll: async (): Promise<Supplier[]> => {
    const response = await client.get('/suppliers');
    return response.data.data;
  },

  getById: async (id: number): Promise<Supplier> => {
    const response = await client.get(`/suppliers/${id}`);
    return response.data.data;
  },

  create: async (data: CreateSupplierRequest): Promise<Supplier> => {
    const response = await client.post('/suppliers', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreateSupplierRequest>): Promise<Supplier> => {
    const response = await client.put(`/suppliers/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/suppliers/${id}`);
    return response.data;
  },
};
